export function getHorarioStatus(horarios) {
    if (!horarios) return { status: "unknown", label: "Sin horario" };

    const dias = [
        "Domingo", "Lunes", "Martes", "Miércoles",
        "Jueves", "Viernes", "Sábado"
    ];

    const now = new Date();
    const diaActual = dias[now.getDay()];
    const config = horarios[diaActual];

    // No abre este día
    if (!config?.open) return { status: "closed", label: "Cerrado hoy" };

    const [hA, mA] = (config.apertura || "00:00").split(":").map(Number);
    const [hC, mC] = (config.cierre || "00:00").split(":").map(Number);

    const apertura = new Date(now); apertura.setHours(hA, mA, 0, 0);
    const cierre = new Date(now); cierre.setHours(hC, mC, 0, 0);

    // Caso: aún no abre hoy
    if (now < apertura) {
        return { status: "closed", label: `Abre a las ${config.apertura} hrs` };
    }

    // Caso: ya cerró hoy
    if (now >= cierre) {
        return { status: "closed", label: "Cerrado hoy" };
    }

    // Si faltan menos de 30 min para cerrar → "cerrando pronto"
    const diffMin = Math.floor((cierre - now) / 60000);
    if (diffMin <= 30) {
        return { status: "closing", label: `Cierra pronto (${diffMin} min)` };
    }

    // Abierto normal
    return { status: "open", label: `Abierto hasta ${config.cierre} hrs` };
}
